module.exports = __webpack_public_path__ + "static/media/semiboquilla-01.c1d89a38.jpg";